export default {"src":"/_next/static/media/badge-outline.afaaf8a6.svg","height":40,"width":40};